module.exports = __webpack_public_path__ + "static/img/rank_16.0d1e903.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_16.png
// module id = lPSY
// module chunks = 0